import React, { useEffect, useState } from 'react';
import {
  Button,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  supplierItemsFetchData,
  addPurchaseRebateSupplier,
  clearSupplierListData,
} from '../../actions/supplierActions';
import NoRowExistsRow from '../../components/common/noRowExistsRow';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';

const SupplierRebateSearch = () => {
  const dispatch = useDispatch();
  const suppliers = useSelector((state) => state.supplierItems ?? []);
  const isLoading = useSelector(
    (state) => state.supplierItemsIsLoading ?? true,
  );
  const hasErrored = useSelector((state) => state.supplierItemsHasErrored);

  const addErrorMessage = useSelector(
    (state) => state.isNewPurchaseRebateSupplierSaveErrored.message || '',
  );
  const isAddErrorOccurred = useSelector(
    (state) =>
      state.isNewPurchaseRebateSupplierSaveErrored.isSaveErrored || false,
  );
  const isSuccessOccurred = useSelector(
    (state) =>
      state.isNewPurchaseRebateSupplierSaveSuccess.isSavedSuccess || false,
  );

  const [supplierId, setSupplierId] = useState('');
  const [supplierName, setSupplierName] = useState('');
  const [emptyRowString, setEmptyRowString] = useState('');
  const [isError, setIsError] = useState(0);

  useEffect(() => {
    dispatch(clearSupplierListData());
  }, [dispatch]);

  useEffect(() => {
    if (isAddErrorOccurred.isSaveErrored) {
      toast.error(addErrorMessage.message, {
        autoClose: 5000,
        position: 'bottom-left',
      });
    } else if (isSuccessOccurred) {
      toast.success('Supplier added successfully', {
        autoClose: 5000,
        position: 'bottom-left',
      });
    }
  }, [isAddErrorOccurred, addErrorMessage, isSuccessOccurred]);

  const handleIdInputChange = (ev) => setSupplierId(ev.target.value);
  const handleNameInputChange = (e) => setSupplierName(e.target.value);

  const searchButtonClick = () => {
    dispatch(supplierItemsFetchData(supplierId, supplierName));
  };

  const addNewPrSupplier = (id, name) => {
    const prSupplier = {
      SupplierId: id,
      Name: name,
      IsActive: true,
    };
    dispatch(addPurchaseRebateSupplier(prSupplier));
  };

  const supplierRows =
    suppliers && suppliers.length > 0 ? (
      suppliers.map((supplier) => (
        <div className='panel panel-default' key={supplier.id}>
          <Row>
            <Col md='1' className='white-border'>
              {supplier.supplierId}
            </Col>
            <Col md='8' className='white-border'>
              {supplier.name}
            </Col>
            <Col md='3' className='white-border'>
              <Button
                onClick={() =>
                  addNewPrSupplier(supplier.supplierId, supplier.name)
                }
              >
                Add
              </Button>
            </Col>
          </Row>
        </div>
      ))
    ) : !isLoading ? (
      <NoRowExistsRow emptyRowText={emptyRowString} />
    ) : (
      <></>
    );

  return (
    <div>
      <ToastContainer toastClassName='ppcToastContainer' />
      <Card>
        <CardHeader>
          <h4>Search for a Supplier</h4>
        </CardHeader>
        <CardBody>
          <FormGroup>
            <Label>Supplier ID</Label>
            <Input
              id='supplierIdInpt'
              onChange={handleIdInputChange}
              className='form-control'
            />
          </FormGroup>
          <h5>Or</h5>
          <FormGroup>
            <Label>Supplier Name</Label>
            <Input
              id='supplierNameInpt'
              onChange={handleNameInputChange}
              className='form-control'
            />
          </FormGroup>
          <Button onClick={searchButtonClick} color='primary'>
            Search
          </Button>
          <Link to='/supplier-rebate'>
            <Button className='ms-3'>Back</Button>
          </Link>
          {hasErrored && (
            <div className='alert alert-dangexr mt-3'>
              Unable to fetch suppliers. Please try again later.
            </div>
          )}
        </CardBody>
      </Card>
      <Container fluid className='mt-3'>
        <Row>
          <Col md='1' className='column-header white-border'>
            Supplier ID
          </Col>
          <Col md='8' className='column-header white-border'>
            Supplier Name
          </Col>
          <Col md='3' className='column-header white-border'>
            Actions
          </Col>
        </Row>
        <Row>
          <Col>
            <BeatLoader color={'#004C5F'} loading={isLoading} />
          </Col>
        </Row>
        {supplierRows}
      </Container>
    </div>
  );
};

export default SupplierRebateSearch;
